export default __webpack_public_path__ + "static/media/Left.53e36d06.svg";